// extracted by mini-css-extract-plugin
module.exports = {"contactProcess":"ContactProcess_contactProcess__bCroW","inner":"ContactProcess_inner__NGjX7","title":"ContactProcess_title__Xw36v"};